_collow.components.AdminManageGroupMembers = class AdminManageGroupMembers extends (
    _collow.components.Base
) {
    root;
    elements;
    params;

    constructor(root, elements, params) {
        super();

        this.root = root;
        this.elements = elements;
        this.params = params;

        this.users = [];
        this.members = [];

        this.selectedUser = [];
        this.selectedMember = [];

        this.changedUserIDs = [];

        this.originalTitle = this.elements.title.textContent;
        this.getGroupInfo();

        this.listen(elements.buttonAdd, "click", (event) => this.handleAddUser(event));
        this.listen(elements.buttonRemove, "click", (event) => this.handleRemoveUser(event));
        this.listen(elements.buttonSave, "click", (event) => this.handleSave(event));
        this.listen(elements.buttonBack, "click", (event) => this.manageBackButton(event));
        this.listen(elements.usersSearch, "input", (event) => this.handleSearch(event, "users"));
        this.listen(elements.membersSearch, "input", (event) => this.handleSearch(event, "members"));
        this.listen(document, "click", (event) => this.handlePopupClose(event));
    }

    groupInfo = null
    users = []
    members = []
    changedUserIDs = []
    selectedUser = []
    selectedMember = []
    originalTitle = null

    getGroupInfo = async () => {
        this.groupInfo = null;

        const currentURL = new URL(window.location);
        const groupId = currentURL.searchParams.get("group_id");

        const baseUrl = this.params.path + `/admin/group`;

        let url = new URL(baseUrl);
        url.searchParams.append("group_id", groupId);

        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: window.localStorage.getItem("token"),
            },
        });
        if (!response.ok) {
            console.error("Unable to fetch groupExtendedInfo - msg: " + response)
        }

        this.groupInfo = await response.json();
        this.setPageTitle(this.groupInfo.name);

        this.members = this.groupInfo.users;
        this.populateMembersList(this.groupInfo.users);

        this.getUsers();
    }

    /**
     * sets the page title based on the group name
     * @param {*} groupName 
     */
    setPageTitle = (groupName) => {
        this.elements.title.textContent = this.originalTitle.replace("{group}", groupName);
    }

    /**
     * Fetches the list of users from the server and populates the users list, 
     * Removing the users that are already members of the group.
     * @returns {Promise<void>} A promise that resolves when the users list is populated.
     */
    getUsers = async () => {
        const response = await fetch(this.params.path + "/admin/user", {
            method: "get",
            headers: {
                Authorization: window.localStorage.getItem("token"),
            },
        });
        if (!response.ok) return;

        const users = await response.json();

        this.users = users.filter(user => {
            return !this.groupInfo.users.some(member => member.user_id === user.user_id);
        });

        this.populateUsersList(this.users);
    }

    /**
     * Populates the users list with the provided users.
     *
     * @param {Array} users - The array of users to populate the list with.
     */
    populateUsersList = (users) => {
        const usersList = this.elements.userList;
        usersList.textContent = '';
        usersList.innerHTML = '';

        users.forEach(user => {
            const child = this.generateUserListEntry(user);
            usersList.appendChild(child);
        });
    }

    /**
     * Populates the members list with the provided members.
     *
     * @param {Array} members - The array of members to populate the list with.
     */
    populateMembersList = (members) => {
        const membersList = this.elements.memberList;
        membersList.textContent = '';
        membersList.innerHTML = '';

        members.forEach(member => {
            const child = this.generateMemberListEntry(member);
            membersList.appendChild(child);
        });
    }

    /**
     * Clears the search bars.
     */
    clearSearchBars = () => {
        this.elements.usersSearch.value = '';
        this.elements.membersSearch.value = '';
    }

    /**
     * Generates a list entry for a member.
     *
     * @param {Object} member - The member object.
     * @returns {HTMLLIElement} - The list entry element.
     */
    generateMemberListEntry = (member) => {
        const checkboxElement = document.createElement("input");
        checkboxElement.setAttribute("type", "checkbox");
        checkboxElement.style.marginRight = "8px";
        const li = document.createElement("li");
        li.style.justifyContent = "start";
        const userName = document.createElement("span");
        userName.textContent = this.getUserName(member);
        checkboxElement.style.pointerEvents = "none";

        li.append(checkboxElement);
        li.appendChild(userName);
        li.dataset.userID = member.user_id;

        li.title = userName.textContent;

        li.addEventListener("click", (e) => {
            e.preventDefault();

            checkboxElement.toggleAttribute("checked");
            li.classList.toggle("active");
            if (li.classList.contains("active")) {
                if (
                    this.selectedMember.findIndex(
                        (el) => el.user_id === member.user_id
                    ) === -1
                ) {
                    this.selectedMember.push(member);
                }
            } else {
                this.selectedMember = this.selectedMember.filter(
                    (el) => el.user_id !== member.user_id
                );
            }
        });

        return li;
    };

    /**
     * Generates a user list entry element.
     *
     * @param {Object} user - The user object.
     * @returns {HTMLElement} - The generated list entry element.
     */
    generateUserListEntry = (user) => {
        const checkboxElement = document.createElement("input");
        checkboxElement.setAttribute("type", "checkbox");
        checkboxElement.style.marginRight = "8px";
        const li = document.createElement("li");
        li.style.justifyContent = "start";
        const userName = document.createElement("span");
        userName.textContent = this.getUserName(user);
        checkboxElement.style.pointerEvents = "none";

        li.append(checkboxElement);
        li.appendChild(userName);
        li.dataset.userID = user.user_id;

        li.title = userName.textContent;

        li.addEventListener("click", (e) => {
            e.preventDefault();

            checkboxElement.toggleAttribute("checked");
            li.classList.toggle("active");
            if (li.classList.contains("active")) {
                if (
                    this.selectedUser.findIndex(
                        (el) => el.user_id === user.user_id
                    ) === -1
                ) {
                    this.selectedUser.push(user);
                }
            } else {
                this.selectedUser = this.selectedUser.filter(
                    (el) => el.user_id !== user.user_id
                );
            }
        });

        return li;
    }

    /**
     * Returns the username of a user.
     * If the user has both a firstname and a lastname, the full name will be returned.
     * If the user has only a firstname or an email, that value will be returned.
     *
     * @param {Object} user - The user object.
     * @returns {string} The username of the user.
     */
    getUserName = (user) => {
        let name = user.firstname || user.email;
        if (user.firstname && user.lastname) {
            name += " " + user.lastname;
        }
        return name;
    }

    /**
     * Searches on the list of users or members based on the input value.
     * @param {*} e input event
     * @param {members | users} type list to search on
     */
    handleSearch = (e, type) => {

        switch (type) {
            case "users":
                const filteredUsers = this.users.filter(u => {
                    return this.getUserName(u).toLowerCase().includes(e.target.value.toLowerCase());
                });
                this.populateUsersList(filteredUsers);
                break;
            case "members":
                const filteredMembers = this.members.filter(m => {
                    return this.getUserName(m).toLowerCase().includes(e.target.value.toLowerCase());
                });
                this.populateMembersList(filteredMembers);
                break;
        }
    }

    /**
     * handles the visual selection of a list item
     * @param {*} li 
     */
    handleVisualSelection = (li) => {
        const siblings = li.parentElement.querySelectorAll('li.active');
        for (const sibling of siblings) {
            sibling.classList.remove('active');
        }
        li.classList.add('active');
    }

    /**
     * Handles the add user button click event.
     * @param {*} e 
     * @returns 
     */
    handleAddUser = (e) => {
        e.preventDefault();

        if (!this.selectedUser) {
            return;
        }
        this.selectedUser.forEach((user) => {
            this.updateGroupMembers(user, true);
            this.selectedUser = [];
        });
    };

    /**
     * handles the remove user button click event.
     * @param {*} e 
     * @returns 
     */
    handleRemoveUser = (e) => {
        e.preventDefault();

        if (!this.selectedMember) {
            return;
        }
        this.selectedMember.forEach((member) => {
            this.updateGroupMembers(member, false);
            this.selectedMember = [];
        });
    };

    /**
    * @param {*} state keep track of if there is a eventlistener active and if the popup is active.
    * Arranges popup to show/hide and adds/removes eventlisteners to the buttons
    */
    showHideBackPopup = (state = false) => {
        this.elements.backPopup.myState =
            this.elements.backPopup.myState == undefined
                ? state
                : !this.elements.backPopup.myState;

        const newState = this.elements.backPopup.myState;

        this.elements.backPopup.toggleAttribute("hidden");
        this[newState ? "unlisten" : "listen"](
            this.elements.backPopupLeave,
            "click",
            this.navigateBack
        );
        this[newState ? "unlisten" : "listen"](
            this.elements.backPopupContinue,
            "click",
            this.closePopup
        );

        state;
        if (this.errorbox) {
            this.errorbox = false;
            this.dispatch(this.root, "_collow-input-change");
        }
    }

    closePopup = () => {
        this.dispatch(this.root, "_collow.popup", { type: "close" });
        this.showHideBackPopup();
    }

    handlePopupClose = (event) => {
        event.preventDefault();

        if (!event.target.closest(".group_manage_members__back_confirmation")) {
            if (!this.elements.backPopup.hasAttribute("hidden")) {
                this.closePopup();
            }
        }
    }


    /**
     * Manage back button click event
     * @param {*} e 
     */
    manageBackButton = (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.dispatch(this.root, "_collow.popup", { type: "open" });
        this.showHideBackPopup();
    }

    /**
     * Navigate back to the group page.
     */
    navigateBack = () => {
        this.saveSuccess(false);
        window.location.href = '/group';
    }


    /**
    * Updates the group members and users list
    * @param {*} user 
    * @param {boolean} isAdding 
    */
    updateGroupMembers = (user, isAdding) => {
        const index = this.changedUserIDs.findIndex(
            (id) => id === user.user_id
        );

        if (index === -1) {
            this.changedUserIDs.push(user.user_id);
        } else {
            this.changedUserIDs.splice(index, 1);
        }

        if (isAdding) {
            this.members.push(user);
            this.users = this.users.filter(u => u.user_id !== user.user_id);
        } else {
            this.users.push(user);
            this.members = this.members.filter(u => u.user_id !== user.user_id);
        }

        this.clearSearchBars();

        this.populateMembersList(this.members);
        this.populateUsersList(this.users);
    }

    handleSave = async (e) => {
        e.preventDefault();

        const formdata = new FormData()
        formdata.append("group_id", this.groupInfo.group_id);
        formdata.append("user_id", this.changedUserIDs);

        const url = new URL(this.params.path + "/admin/group/handle-users");

        const response = await fetch(url, {
            method: "PUT",
            headers: {
                Authorization: window.localStorage.getItem("token"),
            },
            body: formdata
        });

        if (!response.ok) {
            console.error(response);
        } else {
            this.saveSuccess(true);
            window.location.href = '/group';
        }
    }


    /**
     * Saves the success message in the local storage
     * @param {*} success
     */
    saveSuccess = (success) => {
        sessionStorage.setItem("group_edit_success", success);
    };
}